import { TypographyOptions } from '@mui/material/styles/createTypography';

export const typography: TypographyOptions = {
  fontFamily: 'Azeret Mono',
  fontWeightRegular: 400,
  fontWeightBold: 600,
  h1: {
    fontSize: '4rem',
    fontWeight: 'normal',
  },
  h2: {
    fontSize: '2.0rem',
    fontWeight: 'normal',
  },
  h3: {
    fontSize: '1.6rem',
    fontWeight: 'bold',
  },
  h4: {
    fontSize: '1rem',
    fontWeight: 'bold',
  },
  body1: {
    fontSize: '1rem',
  },
  body2: {
    fontSize: '0.8rem',
  },
};
